let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("56PYd")).then(() => parcelRequire('8gVta'));